// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/exportations/list',
    name: 'exportations-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/exportations/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'exportations',
    },
  },
]

export default formTable
